import { c as _c } from "react/compiler-runtime";
import { Chip, TeamIcon, UserIcon } from "@flat-ui";
import { formatUserRoleType, getProjectAccessSource } from "@utils/data-display";
/** Tooltip explaining where the member's project role comes from */
function accessTooltip(source, project) {
  switch (source) {
    case "direct":
      return "Assigned directly to this member";
    case "team":
      return "Access comes only from a team this member belongs to";
    case "teamOverDirect":
      return `A team this member belongs to gives a higher role than the direct one: ${project.explicitRole ? formatUserRoleType(project.explicitRole) : ""}`;
  }
}

/**
 * Access cell for the member overview projects table: a chip showing whether
 * the member's role comes from a direct assignment or from one of their teams.
 */
export function MemberGroupProjectAccessCell(t0) {
  const $ = _c(14);
  const {
    project
  } = t0;
  let T0;
  let isDirect;
  let t1;
  let t2;
  let t3;
  if ($[0] !== project) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const source = getProjectAccessSource(project);
      if (!source) {
        t3 = null;
        break bb0;
      }
      isDirect = source === "direct";
      T0 = Chip;
      t1 = isDirect ? "Direct" : "Team";
      t2 = accessTooltip(source, project);
    }
    $[0] = project;
    $[1] = T0;
    $[2] = isDirect;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    T0 = $[1];
    isDirect = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  const t4 = isDirect ? "default" : "tertiary";
  let t5;
  if ($[6] !== isDirect) {
    t5 = isDirect ? <UserIcon /> : <TeamIcon />;
    $[6] = isDirect;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== T0 || $[9] !== t1 || $[10] !== t2 || $[11] !== t4 || $[12] !== t5) {
    t6 = <T0 label={t1} tooltip={t2} color={t4} size="small" icon={t5} />;
    $[8] = T0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}